export default __webpack_public_path__ + "static/media/logo.f0f2e7ad.png";